import { PlaceActionType } from './place-action-type';

export interface SetPlaceNameAction {
  placeKey: string;
  name: string;
  type: PlaceActionType.SetPlaceName;
}

export const setPlaceName = (
  placeKey: string,
  name: string,
): SetPlaceNameAction => ({
  placeKey,
  name,
  type: PlaceActionType.SetPlaceName,
});
